import * as React from 'react';

import { cn } from '@heartplus/ui';

import {
  INLINE_TOKEN_INPUT_ELEMENT_CLASS,
  INLINE_TOKEN_INPUT_WRAPPER_CLASS,
} from './styles';

type EditableTextTokenProps = {
  tokenType: string;
  value: string;
  onValueChange: (nextValue: string) => void;
};

function clampInt(value: number, min: number, max: number) {
  return Math.min(max, Math.max(min, value));
}

export const EditableTextToken: React.FC<EditableTextTokenProps> = ({
  tokenType,
  value,
  onValueChange,
}) => {
  const minChars = 1;
  const maxChars = 60;
  const chars = clampInt((value?.length ?? 0) + 1, minChars, maxChars);
  const inputMode =
    tokenType === 'number' || tokenType === 'percentage' ? 'decimal' : 'text';

  return (
    <span
      contentEditable={false}
      onMouseDown={(event) => event.stopPropagation()}
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
      className={cn(
        'inline-flex items-center',
        INLINE_TOKEN_INPUT_WRAPPER_CLASS,
      )}
    >
      <input
        value={value}
        onChange={(event) => onValueChange(event.target.value)}
        onFocus={(event) => event.currentTarget.select()}
        onClick={(event) => event.currentTarget.select()}
        inputMode={inputMode}
        type="text"
        onMouseDown={(event) => event.stopPropagation()}
        onKeyDown={(event) => event.stopPropagation()}
        className={cn(INLINE_TOKEN_INPUT_ELEMENT_CLASS, 'w-auto')}
        size={chars}
        style={{ width: `${chars}ch` }}
      />
    </span>
  );
};
